import { Box, Grid, styled } from '@mui/material';
import {
  FIXED_FOOTER_HEIGHT,
  SIDE_NAV_WIDTH,
  SIDEBAR_WIDTH,
  STEPPER_HEADER_HEIGHT_WITHOUT_TITLE,
} from 'src/constants';
import { theme } from 'src/utils';

export const OverridesBody = styled(Box)(
  ({ theme }) => `
  border-top: 1px solid ${theme.palette.secondary.lightest};
  height: calc(100vh - ${STEPPER_HEADER_HEIGHT_WITHOUT_TITLE}px - ${FIXED_FOOTER_HEIGHT}px);
  width: calc(100vw - ${SIDE_NAV_WIDTH}px - ${SIDEBAR_WIDTH}px);
  flex-direction: column;
  flex: 1;
`,
);

export const StepContentWrapper = styled(Box)(
  ({ theme }) => `
  border-top: 1px solid ${theme.palette.secondary.lightest};
  height: calc(100vh - ${STEPPER_HEADER_HEIGHT_WITHOUT_TITLE}px - ${FIXED_FOOTER_HEIGHT}px - 20px);
  margin-left: -30px;
  margin-right: -30px;
`,
);

export const StepContentContainer = styled(Grid)`
  height: 100%;
  margin-top: 0;
  flex-wrap: nowrap;
  width: 100%;
`;

export const StyledFilterContainer = styled(Grid)`
  height: 100%;
  border-right: 1px solid ${theme.palette.secondary.lightest};

  &.MuiGrid-item {
    padding-top: 0;
  }
`;

export const ScheduleComponentLayoutWrapper = styled(Grid)`
  height: 100%;
  width: 100%;
`;
